import cn from 'classnames';
import type React from 'react';
import { NavLink } from 'react-router-dom';
import { Close } from '@shared/assets';
import { useMobile } from '@shared/hooks';
import type { CartItem } from '@shared/types/cart';
import { QuantityInput } from '@src/library/components/common';
import { useRemoveProduct, useUpdateQuantity } from '../../model';
import { Attributes } from '../attributes';
import { Price } from '../price';
import * as st from './styles.module.scss';

interface Props {
  product: CartItem;
}

export const ProductCard: React.FC<Props> = ({ product }) => {
  const { count, handleChange, error } = useUpdateQuantity(product.id);
  const { removeProduct } = useRemoveProduct();
  const { isMobile } = useMobile();

  const params = product.storageItem.attributevalue
    .map((param) => param.attribute.id + '=' + param.value.id)
    .join('&');

  return (
    <div className={cn(st.card, error && st.error, st.product)}>
      <div>
        <img className={st.product__image} src={product.image} alt="" />
      </div>
      <div className={st.product__right}>
        <div className={st.product__firstLine}>
          <NavLink to={`/shop/store/products/product/${product.storageItem.product.id}?${params}`}>
            <h3 className={st.product__title}>{product.title}</h3>
          </NavLink>
          <div className={st.card__close} onClick={() => removeProduct(product.id)}>
            <Close />
          </div>
        </div>
        <div className={st.product__rightBody}>
          <div className={st.product__info}>
            <Attributes attributes={product.attributes} />

            <div className={st.product__quantity_title}>
              {isMobile ? (
                <Price
                  price={product.buyer_price}
                  partnerPrice={product.partner_price}
                  quantity={product.count}
                />
              ) : (
                'Количество'
              )}
            </div>
            <div className={st.product__quantity_input}>
              <QuantityInput
                value={Number(count) > product.available ? product.available.toString() : count}
                setValue={handleChange}
                maxQuantity={product.available}
                onDelete={() => removeProduct(product.id)}
              />
            </div>
          </div>
          <div>
            {!isMobile && (
              <Price
                price={product.buyer_price}
                partnerPrice={product.partner_price}
                quantity={product.count}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
